module.exports = __webpack_public_path__ + "img/hyundai_logo_blue.4c4a6cf4.png";